/**
 * en-GB messages added by Phase 4 task S46A (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s46aEnGB = {
    // Data requests: search hits
    'dp.hit.agreement': 'Signed agreement: {title}',
    'dp.hit.compliance_documents': 'Compliance documents ({count})',
    'dp.hit.induction_pass': 'Induction pass',
    'dp.hit.permit': 'Permit {number} ({type})',
    'dp.hit.evacuation_person': 'Evacuation roll call ({kind}), {site}',
    'dp.hit.lone_working': 'Lone working: {sessions} sessions, {contacts} emergency contacts',
    'dp.hit.nfc_cards': 'NFC cards ({count})',
    'dp.hit.delivery': 'Parcel from {carrier}',
    // Data requests: export sections
    'dp.section.agreements': 'Signed agreements',
    'dp.section.compliance_documents': 'Compliance documents',
    'dp.section.compliance_passes': 'Induction passes',
    'dp.section.compliance_attempts': 'Induction quiz attempts',
    'dp.section.permits': 'Permits',
    'dp.section.permit_signatures': 'Permit signatures',
    'dp.section.permit_events': 'Permit history',
    'dp.section.evacuation_people': 'Evacuation roll calls',
    'dp.section.evacuation_marks': 'Evacuation marks',
    'dp.section.lone_working_contacts': 'Lone working emergency contacts',
    'dp.section.lone_working_sessions': 'Lone working sessions',
    'dp.section.lone_working_events': 'Lone working log',
    'dp.section.nfc_cards': 'NFC cards',
    'dp.section.deliveries': 'Parcels',
    // Retention overview
    'dp.retention.compliance_documents': 'Replaced and rejected compliance documents are deleted after this many days.',
    'dp.retention.compliance_attempts': 'Induction quiz attempts are deleted after this many days.',
    'dp.retention.compliance_passes': 'Visitor induction passes are deleted this many days after they expire.',
    'dp.retention.permits': 'Closed permits with no visit are deleted after this many days.',
    'dp.retention.evacuation': 'Ended evacuations and their roll calls are deleted after this many days.',
    'dp.retention.lone_working': 'Finished lone working sessions are deleted after this many days.',
    'dp.retention.deliveries': 'Collected, returned and cancelled parcels are deleted after this many days.',
};
//# sourceMappingURL=s46a.js.map